var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
export default function SingleSlider(_a) {
    var minThreshold = _a.minThreshold, maxThreshold = _a.maxThreshold, gap = _a.gap, value = _a.value, setValue = _a.setValue, hideText = _a.hideText;
    var _b = useState(false), dragging = _b[0], setDragging = _b[1];
    var _c = useState({ left: 0, width: 0 }), rect = _c[0], setRect = _c[1];
    useEffect(function () {
        function handleMove(event) {
            var _a;
            if (!dragging)
                return;
            var clientX = event instanceof MouseEvent ? event.clientX : ((_a = event.touches[0]) === null || _a === void 0 ? void 0 : _a.clientX) || 0;
            var ratio = (clientX - rect.left) / rect.width;
            var newValue = getValueFromRatio(ratio);
            setValue(newValue);
        }
        function handleUp() {
            setDragging(false);
        }
        if (dragging) {
            window.addEventListener('mousemove', handleMove);
            window.addEventListener('mouseup', handleUp);
            window.addEventListener('touchmove', handleMove);
            window.addEventListener('touchend', handleUp);
        }
        return function () {
            window.removeEventListener('mousemove', handleMove);
            window.removeEventListener('mouseup', handleUp);
            window.removeEventListener('touchmove', handleMove);
            window.removeEventListener('touchend', handleUp);
        };
    }, [dragging, rect]);
    function getValueRatio(value) {
        if (value < minThreshold || value > maxThreshold)
            return 0;
        if (minThreshold === maxThreshold)
            return 1;
        return (value - minThreshold) / (maxThreshold - minThreshold);
    }
    function getValueFromRatio(ratio) {
        if (ratio < 0)
            return minThreshold;
        if (ratio > 1)
            return maxThreshold;
        return Math.round((minThreshold + (maxThreshold - minThreshold) * ratio) / gap) * gap;
    }
    function handleDown(event) {
        var _a;
        var sliderBar = (_a = event.currentTarget.parentElement) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        if (sliderBar) {
            setRect({ left: sliderBar.left, width: sliderBar.width });
            setDragging(true);
        }
    }
    function handleClick(event) {
        var sliderBar = event.currentTarget.getBoundingClientRect();
        var clickX = event.clientX - sliderBar.left;
        var ratio = clickX / sliderBar.width;
        var newValue = getValueFromRatio(ratio);
        setValue(newValue);
    }
    var posX = getValueRatio(value);
    return (_jsx(Container, { children: _jsx(SliderWrapper, { children: _jsxs(SliderTrack, { onClick: handleClick, children: [_jsx(SliderFill, { disabled: minThreshold === maxThreshold, style: { left: 0, right: "".concat((1 - posX) * 100, "%") } }), _jsxs(SliderHandle, { onMouseDown: handleDown, onTouchStart: handleDown, style: { left: "".concat(posX * 100, "%") }, children: [_jsx("div", {}), !hideText && _jsx("p", { className: "number", children: value })] })] }) }) }));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  width: 100%;\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  width: 100%;\n"])));
var SliderWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n"], ["\n  position: relative;\n  width: 100%;\n"])));
var SliderTrack = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: 2px;\n  cursor: pointer;\n  height: 4px;\n  position: relative;\n  width: 100%;\n"], ["\n  background-color: ", ";\n  border-radius: 2px;\n  cursor: pointer;\n  height: 4px;\n  position: relative;\n  width: 100%;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.layoutCardLight;
});
var SliderFill = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: 2px;\n  height: 100%;\n  position: absolute;\n"], ["\n  background-color: ", ";\n  border-radius: 2px;\n  height: 100%;\n  position: absolute;\n"])), function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    return (disabled ? 'transparent' : theme.palette.purple);
});
var SliderHandle = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: 50%;\n  cursor: grab;\n  height: 20px;\n  position: absolute;\n  top: -8px;\n  transform: translateX(-50%);\n  transition: background-color 0.2s ease;\n  padding: 4px;\n  width: 20px;\n  z-index: 2;\n\n  & div {\n    background-color: rgba(0, 0, 0, 0.2);\n    border-radius: 50%;\n    height: 100%;\n    width: 100%;\n  }\n\n  &:active {\n    cursor: grabbing;\n  }\n\n  & > p {\n    bottom: ", ";\n    font-size: 16px;\n    left: 50%;\n    position: absolute;\n    top: ", ";\n    transform: translateX(-50%);\n    user-select: none;\n    white-space: nowrap;\n  }\n"], ["\n  background-color: ", ";\n  border-radius: 50%;\n  cursor: grab;\n  height: 20px;\n  position: absolute;\n  top: -8px;\n  transform: translateX(-50%);\n  transition: background-color 0.2s ease;\n  padding: 4px;\n  width: 20px;\n  z-index: 2;\n\n  & div {\n    background-color: rgba(0, 0, 0, 0.2);\n    border-radius: 50%;\n    height: 100%;\n    width: 100%;\n  }\n\n  &:active {\n    cursor: grabbing;\n  }\n\n  & > p {\n    bottom: ", ";\n    font-size: 16px;\n    left: 50%;\n    position: absolute;\n    top: ", ";\n    transform: translateX(-50%);\n    user-select: none;\n    white-space: nowrap;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.purple;
}, function (_a) {
    var textBottom = _a.textBottom;
    return (textBottom ? '-24px' : 'auto');
}, function (_a) {
    var textBottom = _a.textBottom;
    return (textBottom ? 'auto' : '-22px');
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
